
document
.querySelectorAll('.Collapsible-Text_More')
.forEach(( button ) => button.addEventListener('click',onClick))


function onClick ( event ){

    const { target } = event

    const parent = target.parentElement

    const indicator = parent
        .querySelector('.Collapsible-Text_Dot')

    const content = parent
        .querySelector('.Collapsible_Text-Content_Text')


    const computedStyle = window
        .getComputedStyle(content)

    const isHidden = ( computedStyle.overflow == 'hidden' )


    if( isHidden ){

        content.style.maxHeight = 'fit-content'
        content.style.overflow = 'auto'

        target.innerText = `WENIGER LESEN`

        indicator.innerText = ''

    } else {

        content.style.maxHeight = '6em'
        content.style.overflow = 'hidden'

        target.innerText = `MEHR LESEN`

        indicator.innerText = `[...]`
    }
}
